import React from "react";
import PropTypes from "prop-types";

import { Search } from "semantic-ui-react";
import './SearchWithAutocomplete.css';

const SearchWithAutcomplete = (props) => {
    const {
        items,
        value,
        onSearchChange,
        onResultSelect,
        noResultsMessage,
        minCharacters,
        onKeyUp,
        onChangeSelectOption
    } = props;

    return (<div className="c-input c-input--select">
        <Search
            results={items}
            value={value}
            onResultSelect={onResultSelect}
            onSearchChange={onSearchChange}
            noResultsMessage={noResultsMessage}
            minCharacters={minCharacters}
            onKeyUp={onKeyUp}
            onSelectionChange={onChangeSelectOption}
        />
    </div>);
};

SearchWithAutcomplete.propTypes = {
    items: PropTypes.array,
    value: PropTypes.string,
    onSearchChange: PropTypes.func,
    onResultSelect: PropTypes.func,
    noResultsMessage: PropTypes.string,
    minCharacters: PropTypes.number,
    onKeyUp: PropTypes.func,
    onChangeSelectOption: PropTypes.func
};

export default SearchWithAutcomplete;